"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerWarningFlag = void 0;
var CustomerWarningFlag;
(function (CustomerWarningFlag) {
    CustomerWarningFlag["EM_IS_UNDEFINED"] = "Kickoff defined and EM undefined";
    CustomerWarningFlag["HARVEST_IS_UNDEFINED"] = "Harvest id is undefined";
    CustomerWarningFlag["HAS_BUDGET_AND_NO_TEAM"] = "Has budget and no team";
    CustomerWarningFlag["HAS_NO_BUDGET_ON_KICKOFF_DATE"] = "Has no budget on kickoff date";
    CustomerWarningFlag["JIRA_KEY_UNDEFINED"] = "Jira is undefined";
    CustomerWarningFlag["OFFBOARDED_IN_JIRA"] = "Offboardded in Jira";
})(CustomerWarningFlag || (exports.CustomerWarningFlag = CustomerWarningFlag = {}));
//# sourceMappingURL=CustomerWarningFlag.js.map